
export enum SocketChannel {
    QUEUE = "que",
    HELPDESK = "hd",
    CONFIRMATION = "con",
    SYSTEM = "",
  }